var map = {
	"./achieve-image-01.png": "./src/assets/image/template/achieve-image-01.png",
	"./achieve-image-02.png": "./src/assets/image/template/achieve-image-02.png",
	"./achieve-image-03.png": "./src/assets/image/template/achieve-image-03.png",
	"./achieve-image-04.png": "./src/assets/image/template/achieve-image-04.png",
	"./achieve-image-05.png": "./src/assets/image/template/achieve-image-05.png",
	"./achieve-image-06.png": "./src/assets/image/template/achieve-image-06.png",
	"./achieve-image-1.png": "./src/assets/image/template/achieve-image-1.png",
	"./achieve-image-2.png": "./src/assets/image/template/achieve-image-2.png",
	"./achieve-image-3.png": "./src/assets/image/template/achieve-image-3.png",
	"./achieve-image-4.png": "./src/assets/image/template/achieve-image-4.png",
	"./achieve-image-5.png": "./src/assets/image/template/achieve-image-5.png",
	"./achieve-image-6.png": "./src/assets/image/template/achieve-image-6.png",
	"./achieve-image-7.png": "./src/assets/image/template/achieve-image-7.png",
	"./achieve1-image-2.png": "./src/assets/image/template/achieve1-image-2.png",
	"./activityLevel-image-1.png": "./src/assets/image/template/activityLevel-image-1.png",
	"./activityLevel-image-2.png": "./src/assets/image/template/activityLevel-image-2.png",
	"./activityLevel-image-3.png": "./src/assets/image/template/activityLevel-image-3.png",
	"./activityLevel-image-4.png": "./src/assets/image/template/activityLevel-image-4.png",
	"./activityLevel-image-5.png": "./src/assets/image/template/activityLevel-image-5.png",
	"./age-image-1.png": "./src/assets/image/template/age-image-1.png",
	"./age-image-2.png": "./src/assets/image/template/age-image-2.png",
	"./age-image-3.png": "./src/assets/image/template/age-image-3.png",
	"./age-image-4.png": "./src/assets/image/template/age-image-4.png",
	"./boarding_achievement6.png": "./src/assets/image/template/boarding_achievement6.png",
	"./boarding_activity_level.png": "./src/assets/image/template/boarding_activity_level.png",
	"./boarding_body_type.png": "./src/assets/image/template/boarding_body_type.png",
	"./boarding_calculating_your_bmi.png": "./src/assets/image/template/boarding_calculating_your_bmi.png",
	"./boarding_calendar.png": "./src/assets/image/template/boarding_calendar.png",
	"./boarding_drag_round.png": "./src/assets/image/template/boarding_drag_round.png",
	"./boarding_emoji_age.png": "./src/assets/image/template/boarding_emoji_age.png",
	"./boarding_emoji_danger.png": "./src/assets/image/template/boarding_emoji_danger.png",
	"./boarding_emoji_green_heart.png": "./src/assets/image/template/boarding_emoji_green_heart.png",
	"./boarding_emoji_ok.png": "./src/assets/image/template/boarding_emoji_ok.png",
	"./boarding_emoji_strength.png": "./src/assets/image/template/boarding_emoji_strength.png",
	"./boarding_emoji_trophy.png": "./src/assets/image/template/boarding_emoji_trophy.png",
	"./boarding_emoji_warning.png": "./src/assets/image/template/boarding_emoji_warning.png",
	"./boarding_intro_item.png": "./src/assets/image/template/boarding_intro_item.png",
	"./boarding_normal.png": "./src/assets/image/template/boarding_normal.png",
	"./boarding_obese.png": "./src/assets/image/template/boarding_obese.png",
	"./boarding_overweight.png": "./src/assets/image/template/boarding_overweight.png",
	"./boarding_sanjiao.png": "./src/assets/image/template/boarding_sanjiao.png",
	"./boarding_select.png": "./src/assets/image/template/boarding_select.png",
	"./boarding_selected.png": "./src/assets/image/template/boarding_selected.png",
	"./boarding_underweight.png": "./src/assets/image/template/boarding_underweight.png",
	"./boarding_yoga_level.png": "./src/assets/image/template/boarding_yoga_level.png",
	"./boarding_yoga_level1.png": "./src/assets/image/template/boarding_yoga_level1.png",
	"./boarding_yoga_level2.png": "./src/assets/image/template/boarding_yoga_level2.png",
	"./boarding_yoga_level3.png": "./src/assets/image/template/boarding_yoga_level3.png",
	"./boarding_yoga_level4.png": "./src/assets/image/template/boarding_yoga_level4.png",
	"./body_fat1.png": "./src/assets/image/template/body_fat1.png",
	"./body_fat2.png": "./src/assets/image/template/body_fat2.png",
	"./bodypart-image.png": "./src/assets/image/template/bodypart-image.png",
	"./bodytype-image-1.png": "./src/assets/image/template/bodytype-image-1.png",
	"./bodytype-image-2.png": "./src/assets/image/template/bodytype-image-2.png",
	"./bodytype-image-3.png": "./src/assets/image/template/bodytype-image-3.png",
	"./breathCondition-image-1.png": "./src/assets/image/template/breathCondition-image-1.png",
	"./breathCondition-image-2.png": "./src/assets/image/template/breathCondition-image-2.png",
	"./breathCondition-image-3.png": "./src/assets/image/template/breathCondition-image-3.png",
	"./breathCondition-image-4.png": "./src/assets/image/template/breathCondition-image-4.png",
	"./code.png": "./src/assets/image/template/code.png",
	"./dietScreen-image-1.png": "./src/assets/image/template/dietScreen-image-1.png",
	"./dietScreen-image-2.png": "./src/assets/image/template/dietScreen-image-2.png",
	"./dietScreen-image-3.png": "./src/assets/image/template/dietScreen-image-3.png",
	"./dietScreen-image-4.png": "./src/assets/image/template/dietScreen-image-4.png",
	"./dietScreen-image-5.png": "./src/assets/image/template/dietScreen-image-5.png",
	"./dream-bodytype-image-1.png": "./src/assets/image/template/dream-bodytype-image-1.png",
	"./dream-bodytype-image-2.png": "./src/assets/image/template/dream-bodytype-image-2.png",
	"./dream-bodytype-image-3.png": "./src/assets/image/template/dream-bodytype-image-3.png",
	"./energyLevel-image-1.png": "./src/assets/image/template/energyLevel-image-1.png",
	"./energyLevel-image-2.png": "./src/assets/image/template/energyLevel-image-2.png",
	"./energyLevel-image-3.png": "./src/assets/image/template/energyLevel-image-3.png",
	"./energyLevel-image-4.png": "./src/assets/image/template/energyLevel-image-4.png",
	"./eventScreen-image-1.png": "./src/assets/image/template/eventScreen-image-1.png",
	"./eventScreen-image-2.png": "./src/assets/image/template/eventScreen-image-2.png",
	"./eventScreen-image-3.png": "./src/assets/image/template/eventScreen-image-3.png",
	"./eventScreen-image-4.png": "./src/assets/image/template/eventScreen-image-4.png",
	"./eventScreen-image-5.png": "./src/assets/image/template/eventScreen-image-5.png",
	"./eventScreen-image-6.png": "./src/assets/image/template/eventScreen-image-6.png",
	"./eventScreen-image-7.png": "./src/assets/image/template/eventScreen-image-7.png",
	"./eventScreen-image-8.png": "./src/assets/image/template/eventScreen-image-8.png",
	"./familiarity-image-1.png": "./src/assets/image/template/familiarity-image-1.png",
	"./familiarity-image-2.png": "./src/assets/image/template/familiarity-image-2.png",
	"./familiarity-image-3.png": "./src/assets/image/template/familiarity-image-3.png",
	"./flexibilty-image-1.png": "./src/assets/image/template/flexibilty-image-1.png",
	"./flexibilty-image-2.png": "./src/assets/image/template/flexibilty-image-2.png",
	"./flexibilty-image-3.png": "./src/assets/image/template/flexibilty-image-3.png",
	"./generationScreen-image.png": "./src/assets/image/template/generationScreen-image.png",
	"./happybody-image-1.png": "./src/assets/image/template/happybody-image-1.png",
	"./happybody-image-2.png": "./src/assets/image/template/happybody-image-2.png",
	"./happybody-image-3.png": "./src/assets/image/template/happybody-image-3.png",
	"./happybody-image-4.png": "./src/assets/image/template/happybody-image-4.png",
	"./happybody-image-5.png": "./src/assets/image/template/happybody-image-5.png",
	"./icon_star_light.png": "./src/assets/image/template/icon_star_light.png",
	"./img_age_right.png": "./src/assets/image/template/img_age_right.png",
	"./img_app1.png": "./src/assets/image/template/img_app1.png",
	"./img_app2.png": "./src/assets/image/template/img_app2.png",
	"./img_app3.png": "./src/assets/image/template/img_app3.png",
	"./img_appStore.png": "./src/assets/image/template/img_appStore.png",
	"./img_app_details_left.png": "./src/assets/image/template/img_app_details_left.png",
	"./img_app_details_right.png": "./src/assets/image/template/img_app_details_right.png",
	"./img_apple.png": "./src/assets/image/template/img_apple.png",
	"./img_back_black.png": "./src/assets/image/template/img_back_black.png",
	"./img_back_ob.png": "./src/assets/image/template/img_back_ob.png",
	"./img_back_ob2.png": "./src/assets/image/template/img_back_ob2.png",
	"./img_brand_mastercard.png": "./src/assets/image/template/img_brand_mastercard.png",
	"./img_brand_stripe.png": "./src/assets/image/template/img_brand_stripe.png",
	"./img_brand_visa.png": "./src/assets/image/template/img_brand_visa.png",
	"./img_chart_down.png": "./src/assets/image/template/img_chart_down.png",
	"./img_chart_fair.png": "./src/assets/image/template/img_chart_fair.png",
	"./img_chart_up.png": "./src/assets/image/template/img_chart_up.png",
	"./img_customized_programs.png": "./src/assets/image/template/img_customized_programs.png",
	"./img_email.png": "./src/assets/image/template/img_email.png",
	"./img_email_lock.png": "./src/assets/image/template/img_email_lock.png",
	"./img_email_star.png": "./src/assets/image/template/img_email_star.png",
	"./img_emoji1.png": "./src/assets/image/template/img_emoji1.png",
	"./img_emoji2.png": "./src/assets/image/template/img_emoji2.png",
	"./img_emoji3.png": "./src/assets/image/template/img_emoji3.png",
	"./img_fascinating_features.png": "./src/assets/image/template/img_fascinating_features.png",
	"./img_hint1.png": "./src/assets/image/template/img_hint1.png",
	"./img_hint2.png": "./src/assets/image/template/img_hint2.png",
	"./img_hint_phone.png": "./src/assets/image/template/img_hint_phone.png",
	"./img_homepage_right.png": "./src/assets/image/template/img_homepage_right.png",
	"./img_homepage_right_black.png": "./src/assets/image/template/img_homepage_right_black.png",
	"./img_honor1.png": "./src/assets/image/template/img_honor1.png",
	"./img_honor2.png": "./src/assets/image/template/img_honor2.png",
	"./img_item_left.png": "./src/assets/image/template/img_item_left.png",
	"./img_item_right.png": "./src/assets/image/template/img_item_right.png",
	"./img_loading.png": "./src/assets/image/template/img_loading.png",
	"./img_log_out.png": "./src/assets/image/template/img_log_out.png",
	"./img_menu.png": "./src/assets/image/template/img_menu.png",
	"./img_menu_back.png": "./src/assets/image/template/img_menu_back.png",
	"./img_menu_black.png": "./src/assets/image/template/img_menu_black.png",
	"./img_menu_close.png": "./src/assets/image/template/img_menu_close.png",
	"./img_ob_title_logo.png": "./src/assets/image/template/img_ob_title_logo.png",
	"./img_pay_success.png": "./src/assets/image/template/img_pay_success.png",
	"./img_payment_gift.png": "./src/assets/image/template/img_payment_gift.png",
	"./img_payment_intercept.png": "./src/assets/image/template/img_payment_intercept.png",
	"./img_paywall_badge.png": "./src/assets/image/template/img_paywall_badge.png",
	"./img_paywall_focus_areas_select.png": "./src/assets/image/template/img_paywall_focus_areas_select.png",
	"./img_paywall_plan1.png": "./src/assets/image/template/img_paywall_plan1.png",
	"./img_paywall_plan2.png": "./src/assets/image/template/img_paywall_plan2.png",
	"./img_paywall_plan3.png": "./src/assets/image/template/img_paywall_plan3.png",
	"./img_paywall_plan4.png": "./src/assets/image/template/img_paywall_plan4.png",
	"./img_paywall_qa1.png": "./src/assets/image/template/img_paywall_qa1.png",
	"./img_paywall_qa2.png": "./src/assets/image/template/img_paywall_qa2.png",
	"./img_paywall_qa3.png": "./src/assets/image/template/img_paywall_qa3.png",
	"./img_paywall_select.png": "./src/assets/image/template/img_paywall_select.png",
	"./img_paywall_selected.png": "./src/assets/image/template/img_paywall_selected.png",
	"./img_paywall_star.png": "./src/assets/image/template/img_paywall_star.png",
	"./img_paywall_stared.png": "./src/assets/image/template/img_paywall_stared.png",
	"./img_paywall_target.png": "./src/assets/image/template/img_paywall_target.png",
	"./img_paywall_time.png": "./src/assets/image/template/img_paywall_time.png",
	"./img_paywall_weight.png": "./src/assets/image/template/img_paywall_weight.png",
	"./img_plan_calendar.png": "./src/assets/image/template/img_plan_calendar.png",
	"./img_policy_back.png": "./src/assets/image/template/img_policy_back.png",
	"./img_product_money_bg.png": "./src/assets/image/template/img_product_money_bg.png",
	"./img_professional_coaches.png": "./src/assets/image/template/img_professional_coaches.png",
	"./img_pwd_close.png": "./src/assets/image/template/img_pwd_close.png",
	"./img_pwd_open.png": "./src/assets/image/template/img_pwd_open.png",
	"./img_reviews_top.png": "./src/assets/image/template/img_reviews_top.png",
	"./img_safety.png": "./src/assets/image/template/img_safety.png",
	"./img_star.png": "./src/assets/image/template/img_star.png",
	"./img_stripe.png": "./src/assets/image/template/img_stripe.png",
	"./img_tailored_workouts.png": "./src/assets/image/template/img_tailored_workouts.png",
	"./img_user1.png": "./src/assets/image/template/img_user1.png",
	"./img_user2.png": "./src/assets/image/template/img_user2.png",
	"./img_user3.png": "./src/assets/image/template/img_user3.png",
	"./img_video_first.png": "./src/assets/image/template/img_video_first.png",
	"./intro-image-1-cy.png": "./src/assets/image/template/intro-image-1-cy.png",
	"./intro-image-1.png": "./src/assets/image/template/intro-image-1.png",
	"./intro-image-2.png": "./src/assets/image/template/intro-image-2.png",
	"./intro-image-3.png": "./src/assets/image/template/intro-image-3.png",
	"./intro-image-4.png": "./src/assets/image/template/intro-image-4.png",
	"./intro-image-5.png": "./src/assets/image/template/intro-image-5.png",
	"./intro-image-6.png": "./src/assets/image/template/intro-image-6.png",
	"./normal.png": "./src/assets/image/template/normal.png",
	"./normal1.png": "./src/assets/image/template/normal1.png",
	"./normal2.png": "./src/assets/image/template/normal2.png",
	"./obese.png": "./src/assets/image/template/obese.png",
	"./obese1.png": "./src/assets/image/template/obese1.png",
	"./obese2.png": "./src/assets/image/template/obese2.png",
	"./overweight.png": "./src/assets/image/template/overweight.png",
	"./overweight1.png": "./src/assets/image/template/overweight1.png",
	"./overweight2.png": "./src/assets/image/template/overweight2.png",
	"./paywall_body_type1.png": "./src/assets/image/template/paywall_body_type1.png",
	"./paywall_body_type2.png": "./src/assets/image/template/paywall_body_type2.png",
	"./paywall_body_type3.png": "./src/assets/image/template/paywall_body_type3.png",
	"./paywall_body_type4.png": "./src/assets/image/template/paywall_body_type4.png",
	"./paywall_dream_body_type1.png": "./src/assets/image/template/paywall_dream_body_type1.png",
	"./paywall_dream_body_type2.png": "./src/assets/image/template/paywall_dream_body_type2.png",
	"./paywall_dream_body_type3.png": "./src/assets/image/template/paywall_dream_body_type3.png",
	"./paywall_dream_body_type4.png": "./src/assets/image/template/paywall_dream_body_type4.png",
	"./preferredPosition-image-1.png": "./src/assets/image/template/preferredPosition-image-1.png",
	"./preferredPosition-image-2.png": "./src/assets/image/template/preferredPosition-image-2.png",
	"./preferredPosition-image-3.png": "./src/assets/image/template/preferredPosition-image-3.png",
	"./purpost-image-1.png": "./src/assets/image/template/purpost-image-1.png",
	"./purpost-image-2.png": "./src/assets/image/template/purpost-image-2.png",
	"./restriction-image-1.png": "./src/assets/image/template/restriction-image-1.png",
	"./restriction-image-2.png": "./src/assets/image/template/restriction-image-2.png",
	"./restriction-image-3.png": "./src/assets/image/template/restriction-image-3.png",
	"./restriction-image-3.png.png": "./src/assets/image/template/restriction-image-3.png.png",
	"./restriction-image-4.png": "./src/assets/image/template/restriction-image-4.png",
	"./restriction-image-5.png": "./src/assets/image/template/restriction-image-5.png",
	"./restriction-image-6.png": "./src/assets/image/template/restriction-image-6.png",
	"./restriction-image-7.png": "./src/assets/image/template/restriction-image-7.png",
	"./sleepHourScreen-image.png": "./src/assets/image/template/sleepHourScreen-image.png",
	"./summary-image-1.png": "./src/assets/image/template/summary-image-1.png",
	"./summary-image-2.png": "./src/assets/image/template/summary-image-2.png",
	"./summary-image-3.png": "./src/assets/image/template/summary-image-3.png",
	"./summary-image-4.png": "./src/assets/image/template/summary-image-4.png",
	"./transition-mainimage.png": "./src/assets/image/template/transition-mainimage.png",
	"./underweight.png": "./src/assets/image/template/underweight.png",
	"./underweight1.png": "./src/assets/image/template/underweight1.png",
	"./underweight2.png": "./src/assets/image/template/underweight2.png",
	"./walkingDuration-image-1.png": "./src/assets/image/template/walkingDuration-image-1.png",
	"./walkingDuration-image-2.png": "./src/assets/image/template/walkingDuration-image-2.png",
	"./walkingDuration-image-3.png": "./src/assets/image/template/walkingDuration-image-3.png",
	"./waterDrinkScreen-image-1.png": "./src/assets/image/template/waterDrinkScreen-image-1.png",
	"./waterDrinkScreen-image-2.png": "./src/assets/image/template/waterDrinkScreen-image-2.png",
	"./waterDrinkScreen-image-3.png": "./src/assets/image/template/waterDrinkScreen-image-3.png",
	"./waterDrinkScreen-image-4.png": "./src/assets/image/template/waterDrinkScreen-image-4.png",
	"./weight1.png": "./src/assets/image/template/weight1.png",
	"./weight2.png": "./src/assets/image/template/weight2.png",
	"./weight3.png": "./src/assets/image/template/weight3.png",
	"./yogaLevel-image-1.png": "./src/assets/image/template/yogaLevel-image-1.png",
	"./yogaLevel-image-2.png": "./src/assets/image/template/yogaLevel-image-2.png",
	"./yogaLevel-image-3.png": "./src/assets/image/template/yogaLevel-image-3.png",
	"./yogaLevel-image-4.png": "./src/assets/image/template/yogaLevel-image-4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/template sync recursive ^\\.\\/.*$";